<template>
  <div class="nuttrema-index-holder">
    <div class="nuttrema-index-list">
      <div class="nuttrema-index-list__wrap">

        <div class="nuttrema-index-list__header">
          <nuttrema-index-list-header :loading="isLoading">
            <nuttrema-filter-by-origin
              :filters="_get(state, 'meta.filters', [])"
              @filterByOrigin="handleFilterByOrigin">
            </nuttrema-filter-by-origin>

            <nuttrema-group-and-sort
              :grouping="_get(state, 'meta.grouping', {})"
              :sorting="_get(state, 'meta.sorting', {})"
              @changeGroupBy="handleChangeGroupBy"
              @changeSortBy="handleChangeSortBy"
              @changeOrder="handleChangeOrder">
            </nuttrema-group-and-sort>

            <nuttrema-abc-button
              :showFilterByFirstLetter="showFilterByFirstLetter"
              @show="handleABCShowFilterByFirstLetter">
            </nuttrema-abc-button>
          </nuttrema-index-list-header>

          <nuttrema-filter-by-letters
            :letter="_get(params, 'letter')"
            :showFilters="showFilterByFirstLetter"
            @filterByFirstLetter="handleFilterByFirstLetter">
          </nuttrema-filter-by-letters>
          <!-- end ~ nuttrema-filter-by-letters -->
        </div>

        <div class="nuttrema-index-list__container" ref="ref-id-nuttrema-index-list-container">
          <nuttrema-loader v-if="isLoading"></nuttrema-loader>

          <nuttrema-empty-result
             v-else-if="isError"
             class="with-logo"
             predefined-set="forbiden"
            :sub-title="_get(isError, 'message')">
          </nuttrema-empty-result>

          <nuttrema-empty-result
            v-else-if="isSearchEmpty"
            class="with-logo"
            predefined-set="landscape">
            <template slot="text">
              <h1 v-html="$t('label.result_is_empty')"></h1>
              <h4 v-html="$t('label.redefine_search')"></h4>
            </template>
          </nuttrema-empty-result>

          <nuttrema-empty-result
            v-else-if="isEmpty"
            class="with-logo"
            predefined-set="landscape">
          </nuttrema-empty-result>

          <nuttrema-index-list-content
             v-else
             :scrollTargetID="scrollTargetID"
            @scrollTop="handleScrollTop">
            <nuttrema-index-list-item v-for="(group, key) in state.data" :group="group" :key="key" :meta="meta" :params="params" :permissions="permissions"></nuttrema-index-list-item>
          </nuttrema-index-list-content>
        </div>
        <!-- end ~ nuttrema-index-list__container -->

        <transition name="glide" :duration="500" enter-active-class="animated is-speed slideInUp" leave-active-class="animated is-speed slideOutDown">
          <div class="nuttrema-index-list__footer">
            <div class="nuttrema-index-list__footer--hover">
              <button-resize-toggler
                 v-if="totalPages === 1"
                 theme="gray"
                 class="is-on-top"
                 vertical-correction="0.5em"
                :title="$t('label.close')"
                :collapsed="showPagination"
                @click="showPagination = !showPagination">
              </button-resize-toggler>
            </div>
            <el-pagination
               v-show="showPagination"
               background
               layout="slot, sizes, prev, pager, next, jumper"
              :total="totalResults"
              :current-page="propCurrentPage"
              :page-size="propPageSize"
              :page-sizes="pageSizes"
              @size-change="handlePageSizeChange"
              @current-change="handleCurrentChange">
              <span class="el-pagination__result_per_page">{{ $t('label.result_per_page') }}</span>
            </el-pagination>
          </div>
        </transition>
      </div>
    </div>
    <!-- end ~ nuttrema-index-list     -->
  </div>
</template>

<script>
/* eslint-disable object-shorthand */
import { has, get, assign, each, isNil } from 'lodash';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

import NuttremaFilterByOrigin from 'components/ui/panels/nuttrema-filter-by-origin';
import NuttremaGroupAndSort from 'components/ui/list/nuttrema-group-and-sort';
import NuttremaFilterByLetters from 'components/ui/panels/nuttrema-filter-by-letters';
import NuttremaAbcButton from 'components/ui/panels/nuttrema-abc-button';

import ButtonResizeToggler from 'components/ui/button/button-resize-toggler';

import NuttremaIndexListHeader from './nuttrema-index-list-header';
import NuttremaIndexListContent from './nuttrema-index-list-content';
import NuttremaIndexListItem from './nuttrema-index-list-item';

import NuttremaIndexListButtonAddNew from './nuttrema-index-list-button-add-new';

export default {
  name: 'nuttrema-index-list',
  props: {
    state: {
      type: Object,
      required: true,
      default: null,
    },
    params: {
      required: false,
      default: null,
    },
    propPageSize: {
      type: Number,
      default: 25,
    },
    propCurrentPage: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: null,
    },
    showFilters: {
      type: Boolean,
      default: false,
    },
    meta: {
      required: false,
    },
    returnQuery: {
      required: false,
      default: null,
    },
    permissions: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaLoader,
    NuttremaAbcButton,
    NuttremaEmptyResult,
    ButtonResizeToggler,
    NuttremaGroupAndSort,
    NuttremaIndexListItem,
    NuttremaFilterByOrigin,
    NuttremaFilterByLetters,
    NuttremaIndexListHeader,
    NuttremaIndexListContent,
    NuttremaIndexListButtonAddNew,
  },
  data() {
    return {
      groupBy: null,
      currentPage: 1,
      scrollTargetID: null,
      // isSearchEmpty: false,
      pageSizes: [10, 25, 50, 100],
      showFilterByFirstLetter: false,
      showPagination: true,
    };
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageSize = val;
      console.log('handlePageSizeChange');
      this.$emit('pageSizeChange', val);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log('handleCurrentPageChange');
      this.$emit('currentPageChange', val);
    },
    handleFilterByFirstLetter(val) {
      this.$emit('filterByFirstLetter', val);
    },
    handleFilterByOrigin(val) {
      this.$emit('filterByOrigin', val);
    },
    handleChangeGroupBy(val) {
      console.log('handleChangeGroupBy index list', val);
      this.$emit('changeGroupBy', val);
    },
    handleChangeSortBy(val) {
      console.log('handleChangeSortBy index list', val);
      this.$emit('changeSortBy', val);
    },
    handleChangeOrder(val) {
      console.log('changeOrder index list', val);
      this.$emit('changeOrder', val);
    },
    handleABCShowFilterByFirstLetter(val) {
      const letter = get(this.params, 'letter');
      this.showFilterByFirstLetter = val;
      console.log('handleABCShowFilterByFirstLetter', val, letter);
      if (!val && !isNil(letter)) this.$emit('filterByFirstLetter', '');
    },
    handleScrollTop(top) {
      const content = this.$refs['ref-id-nuttrema-index-list-container'];
      if (content) {
        content.scrollTop = top;
      }
    },
  },
  computed: {
    isSearchEmpty() {
      const q = get(this.params, 'q', false) || false;
      const letter = get(this.params, 'letter', false) || false;

      const totalIncludingSpecial = get(this.state, 'meta.pagination.total_including_special', 0);
      const empty = Number(totalIncludingSpecial) === 0;

      return empty && (q || letter);
    },
    isEmpty() {
      const totalIncludingSpecial = get(this.state, 'meta.pagination.total_including_special', 0);

      const listLength = this.list.length;
      const recentLength = get(this.list, '0.items', []).length;

      return Number(totalIncludingSpecial) === 0 && (listLength === 0 || recentLength === 0);
    },
    isLoading() {
      return this.state.fetching;
    },
    isError() {
      return this.state.error;
    },
    isReady() {
      return this.state.ready;
    },
    pageName() {
      return this.$route.meta.breadcrumb;
    },
    totalPages() {
      const totalPages = get(this.state, 'meta.pagination.total_pages', 0);

      this.showPagination = totalPages > 1;

      return totalPages;
    },
    totalResults() {
      return get(this.state, 'meta.pagination.total_results', 0);
    },
    availableGrouping() {
      return has(this.state, 'meta.grouping.available_grouping') ? this.state.meta.grouping.available_grouping : [];
    },
    list() {
      const list = [];
      let counter = 0;
      each(this.state.data, (item) => {
        if (has(item, 'item_type')) {
          if (item.item_type === 'group') {
            counter = 0;
            list.push(assign({}, item));
          } else {
            list.push(assign({}, item, { showHeader: counter === 0 }));
            counter += 1;
          }
        } else {
          list.push(assign({}, item, { showHeader: counter === 0 }));
          counter += 1;
        }
      });
      return list;
    },
  },
  mounted() {
    const letter = get(this.params, 'letter');
    this.showFilterByFirstLetter = !isNil(letter);
    this.scrollTargetID = get(this.$route, 'query.targetID', null);
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  @import "~styles/mixins/gradients";

  $bgColor: #fff;
  $borderColor: #dbe2ef;
  $padding: 0.5em 0.75em;
  .nuttrema-index-holder {
    flex-grow: 1;
    display: flex;
    align-self: stretch;
    flex-direction: row;

    .nuttrema-index-list {
      flex-grow: 1;
      display: flex;
      min-height: 0;
      margin: 0.75em;
      position: relative;
      border-radius: 5px;
      align-self: stretch;
      flex-direction: column;
      background-color: $bgColor;
      border: 2px solid $borderColor;

      > .nuttrema-index-list__wrap {
        flex-grow: 1;
        display: flex;
        align-self: stretch;
        flex-direction: column;

        &.no-flex-grow {
          flex-grow: 0;
        }

        .nuttrema-index-list__header {
          // height: 4em;
          display: flex;
          min-height: 4em;
          color: $gray-light;
          align-self: stretch;
          background-color: #fff;
          flex-direction: column;
          justify-content: center;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          border-bottom: 2px solid $borderColor;
          flex-shrink: 0;

          &.nuttrema-index-list__header--subheader {
            background-color: rgba(#DBE2EF, 0.25);
          }

          .header__title {
            font-size: 1em;
            font-weight: 800;
            text-transform: uppercase;
          }
          // end ~ header__title

          .level, .nav {
            display: flex;
            flex-grow: 1;

            .nav-center--vertical-bottom {
              align-items: flex-end;
            }

            .level-item, .nav-item {
              > .el-dropdown {
                margin-right: 1em;
              }
            }
            .level-item--title, .nav-item--title {
              flex-direction: column;
              align-items: baseline;
              .title {
                font-size: 1.5em;
                margin-bottom: 0;
              }
              .sub-title {
                font-weight: 600;
                color: $gray;
                text-transform: uppercase;
              }
            }
            .level-item--date, .nav-item--date {
              flex-direction: column;
              align-items: flex-end;
              .lbl-date {
                font-weight: 600;
              }
            }
            .level-item--edit-right, .nav-item--edit-right {
              .el-switch {
                margin-left: 0.5em;
              }
            }
          }
          // end ~ .level, .nav
        }
        // end ~ nuttrema-index-list__header

        .nuttrema-index-list__container {
          flex: 1 1 auto;
          height: 0;
          min-width: 0;
          min-height: 0;
          overflow-y: auto;
          position: relative;
          align-self: stretch;
          background-color: lighten($index-list-bg, 2.5%);

          // .nuttrema-index-list__container__list {
          //   flex-grow: 1;
          //   display: flex;
          //   align-self: stretch;
          //   flex-direction: column;
          // }
          // // end ~ > ul
        }
        // end ~ .nuttrema-index-list__container

        .nuttrema-index-list__footer {
          padding: 0.2em 0;
          position: relative;
          text-align: center;
          align-self: stretch;
          color: $tables-style-text-color;
          border-top: 2px solid $borderColor;

          .nuttrema-index-list__footer--hover {
            width: 100%;
            z-index: 10;
            height: 2.5em;
            position: absolute;
            visibility: hidden;
            top: -2.65em; left: 0;
            @include gradient-vertical(rgba(#fff, 0.05), rgba(#fff, 0.85));
          }

          &:hover {
            .nuttrema-index-list__footer--hover {
              visibility: visible;
            }
          }

          /deep/ .el-pagination {
            padding: 0.55em 0.75em;
            .el-pagination__result_per_page {
              float: left;
              color: #5a5e66;
              font-weight: 400;
              margin-right: 0.25em;
            }
            .el-pagination__sizes {
              float: left;
              .el-select .el-input {
                width: 75px;
              }
            }
            .el-pagination__jump {
              float: right;
              @supports (-moz-appearance:none) { float: none; }
              .el-input {
                padding: 0;
                margin-left: 0.5em;
              }
            }
          }
        }
        // end ~ nuttrema-index-list__footer

      }
      // end ~ ul
    }
    // end ~ nuttrema-index-list

    .nuttrema-theme-professional-topography & {
      .nuttrema-index-list {
        margin: 0;
        border: none;
        .nuttrema-index-list__header {}
      }
    }
  }
  // end ~ nuttrema-index-holder
</style>



// WEBPACK FOOTER //
// src/components/ui/list/nuttrema-index-list.vue